/** Routeur SPA minimal basé sur l'History API. */
const routes = [];
let onResolve = null;

export function route(pattern, handler) {
  routes.push({ parts: pattern.split('/').filter(Boolean), handler });
}

export function navigate(path, { replace = false } = {}) {
  if (location.pathname + location.search === path) return;
  history[replace ? 'replaceState' : 'pushState']({}, '', path);
  resolve();
}

function match(pathname) {
  const segs = pathname.split('/').filter(Boolean);
  for (const r of routes) {
    if (r.parts.length !== segs.length) continue;
    const params = {};
    let ok = true;
    for (let i = 0; i < r.parts.length; i++) {
      const p = r.parts[i];
      if (p.startsWith(':')) params[p.slice(1)] = decodeURIComponent(segs[i]);
      else if (p !== segs[i]) { ok = false; break; }
    }
    if (ok) return { handler: r.handler, params };
  }
  return null;
}

function resolve() {
  const m = match(location.pathname);
  if (m) m.handler(m.params);
  else if (onResolve) onResolve(null);
}

export function start(notFound) {
  onResolve = notFound;
  window.addEventListener('popstate', resolve);
  resolve();
}
